import React from "react";
import Team from '../../api/teams'
import TeamCard from "./TeamCard";
import { Link } from "react-router-dom";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const TeamSection = (props) => {
    return (
        <section className="helpass-team-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-12">
                        <div className="wpo-section-title">
                            <span>- Nhóm tác giả -</span>
                            <h2>Gặp gỡ đội ngũ phát triển</h2>
                            <Link onClick={ClickHandler} to="contact" className="theme-btn">Liên hệ ngay</Link>
                        </div>
                    </div>
                </div>
                <div className="team-wrap">
                    <div className="row">
                        {Team.slice(0, 2).map((team, Titem) => (
                            <div className="col-lg-6 col-md-6 col-12" key={Titem}>
                                <TeamCard Ttitle={team.title} Timg={team.img} Tsubtitle={team.subtitle} />
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>

    );
}

export default TeamSection;
